/**
 * Exactly one emoji, as one of three shapes: a two-letter flag (a regional-indicator pair); one of the
 * three subdivision flags that exist in RGI emoji (England, Scotland and Wales — the black flag
 * U+1F3F4, that flag's own tag sequence, and the U+E007F terminator); or a pictograph or keycap with
 * optional skin-tone/presentation selectors and any number of ZWJ-joined pictographs. No other tag
 * sequence is accepted on any base, so invisible tags cannot mint an endless supply of distinct (404)
 * CDN URLs — neither on an arbitrary pictograph nor on the black flag.
 *
 * Room reactions arrive as free strings over two transports and nothing upstream validates them, so
 * this is the one gate that keeps arbitrary text away from the CDN URL builder and the canvas.
 */
const EMOJI_PATTERN = new RegExp(
  '^(?:' +
    '\\p{Regional_Indicator}{2}' +
    // gbeng / gbsct / gbwls — the only tag sequences RGI emoji defines, so the only ones Noto draws.
    '|\\u{1F3F4}\\u{E0067}\\u{E0062}' +
    '(?:\\u{E0065}\\u{E006E}\\u{E0067}|\\u{E0073}\\u{E0063}\\u{E0074}|\\u{E0077}\\u{E006C}\\u{E0073})' +
    '\\u{E007F}' +
    '|(?:\\p{Extended_Pictographic}|[#*0-9]\\uFE0F?\\u20E3)' +
    '(?:\\p{Emoji_Modifier}|\\uFE0F)*' +
    '(?:\\u200D\\p{Extended_Pictographic}(?:\\p{Emoji_Modifier}|\\uFE0F)*)*' +
    ')$',
  'u'
);

/** Longest legitimate sequence (a three-person family with skin tones) is well under this. */
const MAX_LENGTH = 40;

export const isEmoji = (value: unknown): value is string =>
  typeof value === 'string' && value.length > 0 && value.length <= MAX_LENGTH && EMOJI_PATTERN.test(value);
